import { GroupModel } from '../groups/group.model';
import { WorkflowStage } from "./workflow-stage";
import { ActivableModel } from '@app/core/models/shared/activable.model';

export class WorkflowDetailModel extends ActivableModel {

  constructor() {
    super();
    this.WorkflowStages = []
    this.NonERPComptabilityGroup = new GroupModel();
    this.OperationalGroup = new GroupModel();
    this.CanBeDisabled = true;
    this.CanBeModified = true;
    this.IsActive = true;
  }

  public Id: number;

  public Name: string;

  public CreationDate: Date;

  public NonERPComptabilityGroup: GroupModel;

  public OperationalGroup: GroupModel;

  public CanBeModified: boolean;

  public WorkflowStages: Array<WorkflowStage>;
}
